<div class="cp-modal">
	<div class="cp-modal-header" mat-dialog-title align="start">
		<h2>Welcome!</h2>
	</div>

	<mat-dialog-content class="cp-modal-content">
		<h3>{{brandName}} Portal Terms of Use</h3>
		<p>This site, our {{brandName}} Portal, has been developed by PulteGroup, Inc. to enhance 
			communications between Portal users relating to the construction and sale of 
			homes by companies affiliated with PulteGroup, Inc. In addition, we've created 
			this Portal as a courtesy to our home buying customers to provide them with 
			information about their new home, updates regarding construction progress, 
			tips on how to care for their home, and an alternative means to communicate 
			with us and other users of the Portal. By proceeding to view or use this site, 
			you (i.e., each user) accept the terms below and our Website Terms of Use. 
			You may review our Website Terms of Use by clicking 
			<a [href]="termsOfUseUrl" target="_blank">here</a>.
		</p>
		<ul>
			@for (point of bulletPoints; track point) {
				<li>{{point}}</li>
			}
		</ul>
	</mat-dialog-content>

	<mat-checkbox [disableRipple]="true" class="cp-checkbox" [(ngModel)]="agreedToTerms" data-testid="checkbox" [attr.data-ai-dnt]="'dnt'">
		I have read and agree to the <a [href]="termsOfUseUrl" target="_blank">Terms of Use</a>
	</mat-checkbox>

	<mat-dialog-actions class="cp-modal-actions" align="center">
		<button mat-button color="primary" data-testid="accept-button" [disabled]="!agreedToTerms" (click)="agreeToTerms()" [attr.data-ai-dnt]="'dnt'">I Accept</button>
	</mat-dialog-actions>
</div>